
/**
 * @export
 * @enum {string}
 */
export enum ResetPeriod {
    _3 = '3',
    _4 = '4',
    _6 = '6',
    _12 = '12',
    _24 = '24'
}